import axios from "axios";
import { getHeaders, getHeadersSecret } from "../utils/helpers/main";
import endpoints from "./endpoints";

export const addrmsEnquiryApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.rmsenquiryBase,
    method: "POST",
    headers: getHeadersSecret(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const addEnquiryApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.enquiryBase,
    method: "POST",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getDistributorListApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.distributorBase,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getProdutApi = async params => {
    const callResponse = await axios({
        url: endpoints.produtFetch,
        method: "get",
        headers: getHeaders(),
        params,
    })
        .then(response => response.data)
        .catch(err => ({ status: 0, response: err.response, code: err.response.status }));

    return callResponse;
};
